import { Scene } from 'phaser';

export class Logo extends Phaser.GameObjects.Sprite {
  burst;
  logo;

  constructor(scene: Scene, x: number, y: number, texture: string) {
    super(scene, x, y, texture);

    this.burst = scene.add.sprite(x, y, 'radial_burst').setDisplaySize(700, 700);
    this.logo = scene.add.image(x, y, texture);
    this.scene.tweens.add({
      targets: [this.burst],
      props: {
        angle: 360
      },
      ease: Phaser.Math.Easing.Quadratic,
      duration: 50000,
      delay: 270,
      yoyo: false
    });
  }

  setVisible(value: boolean): this {
    this.logo.setVisible(value);
    this.burst.setVisible(value);

    return this;
  }

  setY(value?: number | undefined): this {
    this.logo.setY(value);
    this.burst.setY(value);

    return this;
  }
}
